export default __webpack_public_path__ + "static/media/rejuvenatinglight.2e697650.png";